import React, { useState } from 'react';
import TaxonItem from './taxon-item.jsx';
import coalService from '../../services/CoalService/coal-service.js';

export default function TaxonGenus({ genus, onNavigate, settings, t }) {
    const [expanded, setExpanded] = useState(false);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleExpand = () => {
        if (expanded) {
            setExpanded(false);
            return;
        }
        if (records.length > 0) {
            setExpanded(true);
            return;
        }
        setLoading(true);
        coalService.filterCoalByGenus({ genus_id: genus.id, public: false }).then(response => {
            setRecords(response.data);
            setExpanded(true);
            setLoading(false);
        }).catch(() => {
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
            setLoading(false);
        });
    };

    return (
        <div>
            <TaxonItem
                name={genus.name}
                expandable={true}
                expanded={expanded}
                onExpand={handleExpand}
                onClick={() => onNavigate('genus', genus.id)}
                indent={1}
            />

            {loading && (
                <div style={{ paddingLeft: '3.75rem' }} className="text-white small">
                    <i className="fas fa-spinner fa-pulse fa-xs me-1"/>
                </div>
            )}

            {expanded && records.map(record => (
                <TaxonItem
                    key={record.id}
                    name={record.scientific_name || record.determination || record.genus_name}
                    expandable={false}
                    onClick={() => onNavigate('record', record)}
                    indent={2}
                />
            ))}
        </div>
    );
}